export const ADD_ZONES = 'ADD_ZONES'
export const ADD_ZONE = 'ADD_ZONE'
export const ADD_ZONES_INTERVALS = 'ADD_ZONES_INTERVALS'
